import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withKeys as _withKeys, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tbdc-floatingmenubutton" }
const _hoisted_2 = { class: "tbdc-agent-disclaimer" }
const _hoisted_3 = {
  class: "tbdc-agent",
  ref: "agentChat"
}
const _hoisted_4 = { class: "tbdc-agent-chat-wrapper" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "tbdc-agent-chat-agent tbdc-agent-chat-thinking" }
const _hoisted_9 = { class: "tbdc-agent-chat-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    location: "bottom",
    "close-on-content-click": false,
    modelValue: _ctx.agentMenu,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.agentMenu) = $event))
  }, {
    activator: _withCtx(({ props: menuProps }) => [
      _createVNode(_component_v_tooltip, {
        location: "bottom",
        "open-delay": "250",
        "open-on-hover": true
      }, {
        activator: _withCtx(({ props: tooltipProps }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_btn, _mergeProps({
              icon: "",
              variant: "text"
            }, _ctx.mergeProps(menuProps, tooltipProps)), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("mdi-chat-outline", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 16)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.agentTooltip")), 1)
        ]),
        _: 2
      }, 1024)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_subheader, null, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "IRIS Agent", -1)),
              _createVNode(_component_v_btn, {
                class: "tbdc-agent-remove-filter",
                icon: "",
                variant: "text",
                disabled: !_ctx.filterEnabled,
                onClick: _ctx.removeFilter
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("mdi-filter-remove-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("message.agentDisclaimer")), 1),
          _createVNode(_component_v_divider),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  (!item.isUser)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (item.filterText && item.message)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              class: _normalizeClass(item.className)
                            }, [
                              _createElementVNode("p", null, [
                                _createElementVNode("b", null, _toDisplayString(item.filterText), 1)
                              ]),
                              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                              _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                              (item.message)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    innerHTML: item.message
                                  }, null, 8, _hoisted_5))
                                : _createCommentVNode("", true)
                            ], 2))
                          : (item.filterText && !item.message)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 1,
                                class: _normalizeClass(item.className)
                              }, [
                                _createElementVNode("b", null, _toDisplayString(item.filterText), 1)
                              ], 2))
                            : (_openBlock(), _createElementBlock("td", {
                                key: 2,
                                class: _normalizeClass(item.className),
                                innerHTML: item.message
                              }, null, 10, _hoisted_6))
                      ], 64))
                    : (_openBlock(), _createElementBlock("td", {
                        key: 1,
                        class: _normalizeClass(item.className)
                      }, _toDisplayString(item.message), 3))
                ]))
              }), 128)),
              (_ctx.thinking)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _createElementVNode("td", _hoisted_8, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                        return _createElementVNode("span", {
                          key: n,
                          style: _normalizeStyle({ animationDelay: `${n * 0.3}s` })
                        }, [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                              _createTextVNode("mdi-circle-small", -1)
                            ]))]),
                            _: 1
                          })
                        ], 4)
                      }), 64))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_v_text_field, {
                class: "tbdc-agent-chat-input",
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                modelValue: _ctx.message,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
                placeholder: _ctx.$t('message.agentQuestion'),
                onKeyup: _withKeys(_ctx.onSend, ["enter"])
              }, null, 8, ["modelValue", "placeholder", "onKeyup"]),
              _createVNode(_component_v_btn, {
                class: "tbdc-agent-chat-send",
                icon: "",
                variant: "text",
                disabled: _ctx.thinking,
                onClick: _ctx.onSend
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("mdi-send", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ], 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}